<template>
	<div class="right-block">
		<div class="modal-wrapper" v-bind:class="{ showModal: showModal }" v-on:click.self="closeModal()">
			<div class="modal-content">
				<div class="header" v-on:click="closeModal()">
					<img class="cross" src="../assets/close.png" alt="">
				</div>
				<div class="modal-top">
					<div class="select-wrapper">
						<div class="select-box" v-on:click="openSelect">
							<p class="selected">{{ selected }}</p>
							<ul class="select-list" :class="{ open: selectOpen }">
								<li class="select-item" v-on:click="changeSelect(item)" v-for="item in selectList">{{ item }}</li>
							</ul>
						</div>
						<div class="arrow-box" v-on:click="openSelect">
							<img class="arrow" src="../assets/arrow.png" :class="{ opened: selectOpen }" alt="select">
						</div>
					</div>

					<div class="select-wrapper _size">
						<div class="select-box _small" v-on:click="openSelectSpec">
							<p class="selected">{{ selectedItem }}</p>
							<ul class="select-list" :class="{ open: selectOpenSpec }">
								<li class="select-item _small-item" v-on:click="changeSelectItem(items)" v-for="items in itemList">
									{{ items }}


								</li>
							</ul>
						</div>
						<div class="arrow-box" v-on:click="openSelectSpec">
							<img class="arrow" src="../assets/arrow.png" :class="{ opened: selectOpenSpec }" alt="select">
						</div>
					</div>

					<div class="price-block">
						<p class="price">{{ price }}</p>
					</div>
				</div>
				<div class="modal-middle">
					<div class="row">
						<p class="text">Условия можно уточнить по номеру&nbsp;<a class="text-link" href="+79232226828">+7 923 222-68-28</a>.</p>
						<div class="button" v-on:click="openFinalModal(1)">
							<span class="btn-text">Самовывоз в Новосибирск</span>
						</div>
					</div>
					<div class="row">
						<p class="text-big">Уточняйте наличие!</p>
						<div class="button" v-on:click="openFinalModal(2)">
							<span class="btn-text">Бесплатная доставка по Новосибирску</span>
						</div>
					</div>
					<div class="row">
						<p class="text">Оплаченные сноуборды отправляем в пункты выдачи СДЭК.</p>
						<div class="button" v-on:click="openFinalModal(3)">
							<span class="btn-text">Бесплатная доставка по России</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-wrapper" v-bind:class="{ showModal: showModalFinal }" v-on:click.self="closeFinalModal()">
			<div class="modal-content _final">
				<div class="header" v-on:click="closeFinalModal()">
					<img class="cross" src="../assets/close.png" alt="">
				</div>
				<div class="modal-middle">
					<form action="https://money.yandex.ru/eshop.xml" method="post" v-on:submit="submitForm(this, $event)">
						<input required name="shopId" value="161606" type="hidden"/>
						<input required name="scid" value="713884" type="hidden"/>
						<input required name="sum" value="45000" type="hidden">
						<input name="paymentType" value="AC" type="hidden"/>
						<input name="ym_merchant_receipt" v-model="formData" type="hidden"/>
						<input name="customerNumber" v-model="phone" type="hidden">

						<input name="orderDetails" v-model="computedModel" type="hidden">
						<input name="custName" v-model="name" type="hidden">
						<input name="custEmail" v-model="mail" type="hidden">
						<input name="custAddr" v-model="computedAddress" type="hidden">

						<label class="label" for="name">Имя</label>
						<input name="customerName" id="name" type="text" v-model="name">
						<label class="label" for="phone">Телефон</label>
						<input required name="customerContact" placeholder="+79999999999" id="phone" v-model="phone" type="text">
						<label class="label" for="mail">Электронная почта</label>
						<input required name="customerMail" id="mail" type="email" v-model="mail">
						<label class="label" for="address" v-if="showInput()">Адрес</label>
						<input name="customerAddress" id="address" type="text" v-if="showInput()" v-model="address">
						<label class="label" for="city" v-if="showInputCity()">Город</label>
						<input name="customerCity" id="city" type="text" v-if="showInputCity()" v-model="city">
						<label class="text-big-confirm" for="warning1">Уточняйте наличие!</label>
						<input class="button" :class="{ '_disabled': !isPhone }" type="submit" value="К оплате"/>
					</form>

				</div>
			</div>
		</div>
		<div class="hidden wrapper" :class="{ show:isShow() }">
			<div class="content-wrapper">
				<div class="type-block">
					<span class="type" v-on:click="activate(1)" :class="{ active:isActive(1) }">{{ item1 }}</span>
					<span class="type" v-on:click="activate(2)" :class="{ active:isActive(2) }">{{ item2 }}</span>
					<span class="type" v-on:click="activate(3)" :class="{ active:isActive(3) }">{{ item3 }}</span>
					<span class="type" v-if="item4" v-on:click="activate(4)" :class="{ active:isActive(4) }">{{ item4 }}</span>
					<span class="type" v-if="item5" v-on:click="activate(5)" :class="{ active:isActive(5), none:isNone() }">{{ item5 }}</span>
				</div>
				<div class="desc-wrapper">
					<div class="desc-title">
						<ul>
							<li>жёсткость</li>
							<li>размер креплений</li>
							<li>контактная длина (см)</li>
							<li>ширина носа (см)</li>
							<li>ширина хвоста (см)</li>
							<li>ширина талии (см)</li>
							<li>ширина стойки</li>
							<li>смещение закладных (см)</li>
							<li>боковой радиус (м)</li>
							<li>вес райдера (кг)</li>
						</ul>
					</div>
					<div class="desc-amount">
						<transition-group
										name="fade"
										tag="ul"
										mode="out-in">
							<li v-for="(item, index) in list"
									v-bind:key="item"
									v-bind:data-index="index">
								{{ item }}


							</li>
						</transition-group>
					</div>
				</div>
				<div>
					<buyButton v-bind:active="active"></buyButton>
				</div>
				<!-- <div v-on:click="openModal()">
					<buyButton v-bind:active="active"></buyButton>
				</div> -->
				<a href="tel:+79232226828" class="info">+7 923 222-68-28</a>
				<a href="tel:+79628404755" class="info">+7 962 840-47-55</a>
			</div>
		</div>
	</div>
</template>

<script>
  import buyButton from './buyButton'

  export default {
    name: 'rightBlock',
    props: ['active'],
    data () {
      return {
        showModal: false,
        showModalFinal: false,
        activeItem: 1,
        list: ['MD', 'M/L', '109,1', '29,1', '29,1', '25,3', '54', 0, '7,5', '60-75'],
        itemList: ['151', '155', '160w', '164w'],
        selectedItem: '151',
        item1: '151',
        item2: '155',
        item3: '160w',
        item4: '164w',
        item5: null,
        selected: 'Сноуборд Phantom U (оранжевая база)',
        selectList: [
          'Сноуборд Phantom T',
          'Сноуборд Phantom F (черная база)',
          'Сноуборд Phantom F (белая база)',
          'Сноуборд Phantom U (оранжевая база)',
          'Сноуборд Phantom U (черная база)'
        ],
        selectOpen: false,
        selectOpenSpec: false,
        price: '45000',
        index: 1,
        name: '',
        address: '',
        city: '',
        phone: '',
        mail: ''
      }
		},
		computed: {
			formData () {
				return JSON.stringify({
					"customerContact": this.phone,
					"taxSystem": 3,
					"items":[
						{
							"quantity": 1,
							"price": {
								"amount": this.price
							},
							"tax": 4,
							"text": `${this.selected} ${this.selectedItem}`
						},
					],
					"paymentMethodType": "full_prepayment",
					"paymentSubjectType": "commodity"
				})
			},
			computedAddress () {
				return `${this.address} ${this.city}`
			},
			computedModel () {
				return `${this.selected} ${this.selectedItem}`
			},
			isPhone () {
					let phoneReg = /^\+7[0-9]{10,11}/;

					let isPhone = this.phone.match(phoneReg);

					return isPhone;
			}
		},
    methods: {
			submitForm: function (form, event) {
				if (this.isPhone) {
					form.submit()
				}
				event.preventDefault()
				return false
			},
      showInput: function () {
        return this.index === 2
      },
      showInputCity: function () {
        return this.index === 3
      },
      isShow: function () {
        return this.active === 2 || this.active === 3 || this.active === 4
      },
      closeModal: function () {
        this.showModal = false
        this.showModalFinal = false
      },
      closeFinalModal: function () {
        this.showModalFinal = false
        this.name = ''
        this.address = ''
        this.city = ''
        this.phone = ''
        this.mail = ''
      },
      openModal: function () {
				this.showModal = true

				if (window.innerWidth <= 1250 ) {
					window.scrollTo(0, 0)
				}
      },
      openFinalModal: function (i) {
        this.showModalFinal = true
        this.index = i
      },
      activate: function (index) {
        this.activeItem = index
      },
      isActive: function (index) {
        return this.activeItem === index
      },
      isNone: function () {
        if (this.item5 === 'hid') {
          return true
        } else {
          return false
        }
      },
      changeSelect: function (item) {
        this.selected = item
        if (item === this.selectList[0]) {
          this.itemList = ['151', '155', '160w', '164w']
          this.price = '45000'
        } else if (item === this.selectList[1] || item === this.selectList[2]) {
          this.itemList = ['150', '156', '163w']
          this.price = '45000'
        } else if (item === this.selectList[3] || item === this.selectList[4]) {
          this.itemList = ['151', '156', '161w', '165w', '172w']
          this.price = '45000'
        }
        this.selectedItem = this.itemList[0]
      },
      changeSelectItem: function (item) {
        this.selectedItem = item
      },
      openSelect: function () {
        this.selectOpen = !this.selectOpen
        this.selectOpenSpec = false
      },
      openSelectSpec: function () {
        this.selectOpen = false
        this.selectOpenSpec = !this.selectOpenSpec
      }
    },
    components: {
      buyButton
    },
    watch: {
      activeItem: function () {
        if (this.active === 2) {
					if (this.activeItem === 1) {
            this.list = ['MD', 'M/L', '109,1', '29,1', '29,1', '25,3', '54', 0, '7,5', '60-75']
          } else if (this.activeItem === 2) {
            this.list = ['MD', 'M/L', '112,5', '29,4', '29,4', '25,5', '55', 0, '7,7', '60-75']
          } else if (this.activeItem === 3) {
            this.list = ['HD', 'L', '115,9', '29,9', '29,9', '25,8', '56', 0, '7,9', '75-90']
          } else if (this.activeItem === 4) {
            this.list = ['HD', 'L', '119,2', '30,4', '30,4', '26,2', '57', 0, '8,1', '75-90']
          }
        }
        else if (this.active === 4) {
          if (this.activeItem === 1) {
            this.list = ['MD', 'M', '106,7', '29,6', '28,6', '25,4', '55', '3,4', '7,9', '60-75']
          } else if (this.activeItem === 2) {
            this.list = ['MD', 'M/L', '110,9', '29,7', '28,8', '25,7', '55', '3,6', '8,3', '60-75']
          } else if (this.activeItem === 3) {
            this.list = ['HD', 'L', '114,2', '30,2', '29,3', '26', '56', '3,7', '8,5', '75-90']
          } else if (this.activeItem === 4) {
            this.list = ['HD', 'L', '117,5', '30,7', '29,7', '26,4', '57', '3,7', '8,75', '75-90']
          } else if (this.activeItem === 5) {
            this.list = ['HD+', 'L', '122,3', '30,9', '29,8', '26,4', '57', '3,9', '9,1', '90+']
          }
        }
        else if (this.active === 3) {
          if (this.activeItem === 1) {
            this.list = ['MD', 'M/L', '111,6', '30,2', '27,4', '25', '53', '6,3', '8,1', '60-75']
          } else if (this.activeItem === 2) {
            this.list = ['HD', 'M/L', '116,2', '30,7', '27,8', '25,2', '55', '6,5', '8,3', '75-90']
          } else if (this.activeItem === 3) {
            this.list = ['HD+', 'L', '120,9', '32', '28,9', '26,2', '56', '6,8', '8,5', '90+']
          }
        }
      },
      active: function () {
        this.activeItem = 1
        if (this.active === 2) {
          this.item1 = '151'
          this.item2 = '155'
          this.item3 = '160w'
          this.item4 = '164w'
          this.item5 = null
          this.selected = 'Сноуборд Phantom T'
					this.price = '45000'
					if (this.activeItem === 1) {
            this.list = ['MD', 'M/L', '109,1', '29,1', '29,1', '25,3', '54', 0, '7,5', '60-75']
          } else if (this.activeItem === 2) {
            this.list = ['MD', 'M/L', '112,5', '29,4', '29,4', '25,5', '55', 0, '7,7', '60-75']
          } else if (this.activeItem === 3) {
            this.list = ['HD', 'L', '115,9', '29,9', '29,9', '25,8', '56', 0, '7,9', '75-90']
          } else if (this.activeItem === 4) {
            this.list = ['HD', 'L', '119,2', '30,4', '30,4', '26,2', '57', 0, '8,1', '75-90']
          }
        }
        else if (this.active === 3) {
          this.item1 = '150'
          this.item2 = '156'
          this.item3 = '163w'
          this.item4 = null
          this.item5 = null
          this.selected = 'Сноуборд Phantom F (черная база)'
          this.price = '45000'
          if (this.activeItem === 1) {
            this.list = ['MD', 'M/L', '111,6', '30,2', '27,4', '25', '53', '6,3', '8,1', '60-75']
          } else if (this.activeItem === 2) {
            this.list = ['HD', 'M/L', '116,2', '30,7', '27,8', '25,2', '55', '6,5', '8,3', '75-90']
          } else if (this.activeItem === 3) {
            this.list = ['HD+', 'L', '120,9', '32', '28,9', '26,2', '56', '6,8', '8,5', '90+']
          }
        }
        else if (this.active === 4) {
          this.item1 = '151'
          this.item2 = '156'
          this.item3 = '161w'
          this.item4 = '165w'
          this.item5 = '172w'
          this.price = '45000'
          this.selected = 'Сноуборд Phantom U (оранжевая база)'
          if (this.activeItem === 1) {
            this.list = ['MD', 'M', '106,7', '29,6', '28,6', '25,4', '55', '3,4', '7,9', '60-75']
          } else if (this.activeItem === 2) {
            this.list = ['MD', 'M/L', '110,9', '29,7', '28,8', '25,7', '55', '3,6', '8,3', '60-75']
          } else if (this.activeItem === 3) {
            this.list = ['HD', 'L', '114,2', '30,2', '29,3', '26', '56', '3,7', '8,5', '75-90']
          } else if (this.activeItem === 4) {
            this.list = ['HD', 'L', '117,5', '30,7', '29,7', '26,4', '57', '3,7', '8,75', '75-90']
          } else if (this.activeItem === 5) {
            this.list = ['HD+', 'L', '122,3', '30,9', '29,8', '26,4', '57', '3,9', '9,1', '90+']
          }
        }
      }
    }
  }
</script>

<style scoped>

	.price {
		font-family: opinionprocondensed, serif;
		color: #000000;
		font-size: 26px;
		font-weight: 300;
		line-height: 23.25px;
		padding-top: 19px;
	}

	.modal-top {
		display: flex;
		justify-content: space-between;
		width: 96%;
	}

	.select-wrapper {
		position: relative;
		display: flex;
	}

	.select-list {
		position: absolute;
		top: 62px;
		left: 0;
		opacity: 0;
		z-index: -1;
		display: none;
	}

	.select-item {
		font-family: opinionprocondensed, serif;
		color: #000000;
		font-size: 26px;
		font-weight: 300;
		line-height: 23.25px;
		text-align: left;
		vertical-align: middle;
		width: 416px;
		height: 42px;
		margin: 0;
		padding-left: 20px;
		padding-top: 18px;
		background-color: #fff;
		border: 1px solid #ebebeb;
	}

	.select-item:hover {
		background-color: aliceblue;
	}

	.row {
		display: flex;
		margin-top: 36px;
	}

	.text {
		width: 100%;
		max-width: 373px;
		font-family: opinionprocondensed, serif;
		font-size: 16px;
		padding-left: 18px;
		margin-right: 42px;
		display: flex;
		align-self: center;
	}

	.text-big {
		width: 100%;
		max-width: 373px;
		font-family: opinionprocondensed, serif;
		font-size: 32px;
		padding-left: 18px;
		margin-right: 0px;
		display: flex;
		align-self: center;
	}

	.text-big-confirm {
		width: 100%;
		max-width: 373px;
		font-family: opinionprocondensed, serif;
		font-size: 32px;
		padding-left: 18px;
                padding-bottom: 18px;
		margin-right: 0px;
		display: flex;
		align-self: center;
	}

	.modal-middle {
		padding-top: 36px;
	}

	.button {
		cursor: pointer;
		padding: 18px;
		display: inline-block;
		align-items: center;
		font-family: opinionprocondensed, serif;
		font-size: 26px;
		border-top: 1px solid #fff;
		border-bottom: 1px solid transparent;
		border-left: none;
		border-right: none;
		background-color: #fff;
		box-shadow: 0 10px 35px 5px rgba(0, 0, 0, .1);
	}

	.button._disabled {
		background-color: rgba(220, 220, 220, .4);
		box-shadow: 0 10px 20px 5px rgba(0, 0, 0, .1);
		transition: all .3s ease;
		color: rgba(0, 0, 0, .5);
		cursor: default;
	}

	.arrow-box {
		width: 60px;
		height: 40px;
		padding-top: 20px;
		text-align: center;
		display: inline-block;
		background-color: #fff;
		border: 1px solid #ebebeb;
		cursor: pointer;
		opacity: .8;
	}

	.arrow-box:hover {
		opacity: 1;
	}

	.select-box {
		width: 436px;
		height: 60px;
		background-color: #fff;
		border: 1px solid #ebebeb;
		cursor: pointer;
	}

	.selected {
		font-family: opinionprocondensed, serif;
		color: #000000;
		font-size: 26px;
		font-weight: 300;
		line-height: 23.25px;
		text-align: left;
		vertical-align: middle;
		padding-left: 20px;
		padding-top: 18px;
	}

	.open {
		opacity: 1;
		z-index: 10;
		display: block;
	}

	.opened {
		transform: rotate(180deg);
	}

	.none {
		visibility: hidden;
	}

	.fade-leave, .fade-leave-to {
		display: none;
	}

	.fade-enter-active {
		transition: all .6s ease;
	}

	.fade-leave-active {
		transition: all .8s ease;
	}

	.fade-enter {
		opacity: 0;
	}

	.wrapper {
		display: flex;
		flex-wrap: nowrap;
	}

	.right-block {
		margin: 30px 15px 0;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
	}

	.hidden {
		height: 0;
		visibility: hidden;
		opacity: 0;
	}

	.info {
		font-size: 25px;
		font-family: opinionpro, serif;
		margin-bottom: 16px;
		white-space: nowrap;
		font-weight: 300;
		text-decoration: none;
		color: #000000;
		display: block;
	}

	.text-link {
		font-family: opinionpro, serif;
		font-weight: 300;
		text-decoration: none;
		color: #000000;
		display: block;
	}

	.info-text {
		border-bottom: 1px solid rgba(0, 0, 0, .5);
		cursor: pointer;
	}

	.modal-wrapper {
		position: absolute;
		opacity: 0;
		right: 0;
		left: 0;
		top: 0;
		bottom: 0;
		width: 100%;
		height: 0;
		z-index: -1000;
	}

	.modal-wrapper::before {
		content: '';
		background-color: rgba(0,0,0,.2);
		width: 100%;
		height: 100%;
		position: fixed;
		right: 0;
		left: 0;
		top: 0;
		bottom: 0;
	}

	.showModal {
		height: 100%;
		opacity: 1;
		z-index: 1000;
		transition: opacity ease .6s;
	}

	.modal-content {
		position: fixed;
		width: 969px;
		height: 475px;
		bottom: 0;
		right: 0;
		left: 0;
		top: 0;
		margin: auto;
		padding: 30px 30px 30px 30px;
		border-radius: 4px;
		border: 1px solid rgba(100, 100, 100, .4);
		background-color: #fafafa;
		box-shadow: 0 0 23px 8px rgba(0, 0, 0, .1);
	}

	.header {
		width: 100%;
		height: 40px;
	}

	.cross {
		padding: 8px;
		float: right;
		cursor: pointer;
		transition: transform ease .5s;
	}

	.cross:hover {
		padding: 8px;
		float: right;
		cursor: pointer;
		transform: rotate(90deg);
		transition: transform ease .5s;
	}

	.type-block {
		display: flex;
		margin-bottom: 30px;
	}

	.type {
		font-family: opinionprocondensed, serif;
		font-weight: 400;
		margin-right: 23px;
		cursor: pointer;
		font-size: 26px;
	}

	.type-block > span {
		position: relative;
		color: #000;
		text-decoration: none;
		outline: none;
		padding: 5px 0;
	}

	span:after, span:before {
		position: absolute;
		opacity: 0;
		width: 0;
		height: 1px;
		content: '';
		background: #000;
		transition: all 0.7s;
	}

	span:after {
		left: 0px;
		top: 0px;
	}

	span:before {
		right: 0px;
		bottom: 0px;
	}

	span.active:before {
		opacity: 1;
		width: 100%;
	}

	span.active:after {
		opacity: 1;
		width: 100%;
	}

	.desc-wrapper {
		display: flex;
		justify-content: space-between;
		font-family: opinionprocondensed, serif;
		font-size: 26px;
	}

	.desc-title {
		margin-right: 5px;
	}

	.desc-amount {
		text-align: right;
	}

	li {
		margin-bottom: 11px;
	}

	.show {
		opacity: 1;
		height: auto;
		visibility: visible;
		transition: all ease-out .6s;
	}

	.type:nth-last-child(1) {
		margin-left: 23px;
	}

	.type:nth-last-child(2) {
		margin: 0;
	}

	._small {
		width: 100px;
	}

	._small-item {
		width: 80px;
	}

	._final {
		width: 500px;
		height: max-content;
	}

	.label {
		font-size: 26px;
		padding-left: 42px;
		margin-bottom: 21px;
		font-family: opinionprocondensed, serif;
		display: block;
	}

	._final > .modal-middle {
		padding: 0;
	}

	form > input {
		width: 418px;
		padding: 12px 19px 10px 19px;
		font-family: opinionprocondensed, serif;
		font-size: 26px;
		border: 1px solid #ebebeb;
		outline: none;
		margin: 0 auto 31px;
		display: block;
	}

	form > .button {
		display: block;
		width: auto;
	}

	@media all and (max-width: 1250px) {
		.price-block {
			background-color: #fafafa;
		}

		.modal-content {
			position: absolute;
			width: 270px;
			height: auto;
			bottom: auto;
			top: 60px;
			padding: 10px;
		}

		.modal-top {
			flex-direction: column;
		}

		.selected {
			font-size: 18px;
			padding-left: 10px;
			padding-top: 8px;
		}

		.select-item {
			font-size: 18px;
			height: 45px;
			width: 214px;
			padding-left: 10px;
			padding-top: 8px;
		}

		.select-box {
			width: 243px;
		}

		._small-item {
			height: 30px;
			padding-top: 15px;
		}

		._small > .selected {
			padding-top: 5px;
		}

		._small > .select-list {
			top: 32px;
		}

		._small {
			height: 30px;
		}

		.price {
			padding-top: 11px;
			padding-left: 9px;
		}

		._size {
			margin-top: 20px;
		}

		._size > .arrow-box {
			padding-top: 8px;
			height: 22px;
		}

		.arrow-box {
			width: 32px;
		}

		.row {
			margin-top: 11px;
			flex-direction: column;
			justify-content: center;
		}

		.modal-middle {
			padding-top: 0;
		}

		form > input {
			width: 218px;
			margin-bottom: 15px;
			padding: 8px 19px 7px 19px;
			font-size: 19px;
		}

		form > .button {
			padding: 9px 18px;
		}

		.label {
			padding-left: 25px;
			margin-bottom: 10px;
		}

		.text {
			margin-right: 0;
			font-size: 11px;
		}

		.row > .button {
			padding: 5px;
			font-size: 16px;
			margin-top: 9px;
		}

		._final {
			height: auto;
		}

		.right-block {
			align-items: center;
			max-width: 320px;
		}

		.content-wrapper {
			display: flex;
			flex-direction: column;
			width: 257px;
		}

		.type-block {
			width: 257px;
			justify-content: space-between;
		}

		.type {
			font-size: 20px;
		}

		.desc-wrapper {
			font-size: 20px;
		}

		.info {
			font-size: 17px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/RightBlock.vue?4b8801cf